import React, {Component, Children} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import ActivityLogComponent from './../ActivityLog/ActivityLogComponent';
import NewsFeedComponent from './../NewsFeed/NewsFeedComponent';
import SpotOrderTableComponent from './../TradeBook/SpotOrderTableComponent';
import LimitOrderTableComponent from './../TradeBook/LimitOrderTableComponent';
import FixingOrderTableComponent from './../TradeBook/FixingOrderTableComponent';
import OpenTradeComponent from './../TradeBook/OpenTradeComponent';
import styles from './../TradeBook/TradeBook.less';
import * as dashboardActions from './../../actions/dashboardActions';
import * as activityActions from './../../actions/activityActions';
import * as authActions from '../../redux/modules/auth';
import * as commonActions from './../../actions/commonActions';
import '../../theme/styles/daterangepicker.css';
import 'react-datepicker/dist/react-datepicker.css';
import '../../../node_modules/react-grid-layout/css/styles.css';
import '../../../node_modules/react-resizable/css/styles.css';
import '../../theme/styles/dx-react-grid-bootstrap4.css';
import '../../theme/styles/reactstrap.css';
import i18next from 'i18next';
import {Tabs, Tab, TabPanel, TabList} from 'react-web-tabs';
import HoverTable from './../../components/HoverTable/index.js';
import { applyStyle, applyClickActive,applyToHover,setDirection } from './../../utils/utils';
import track from 'react-tracking';

// const elementsData = [
//   {"classNames":"widgetheader", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"vericalDotIcon", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"closeBtn","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"card-header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"tabName", "elementType":"tabs", "applyTo":"single", "tagNames":"button", "parent":"widgetheader"},
//   {"classNames":"tabName", "elementType":"tabs", "applyTo":"all", "tagNames":"button", "parent":"widgetheader"},
//   {"classNames":"tabHeader", "elementType":"normal", "applyTo":"single", "tagNames":"button"},
//   {"classNames":"widgetwrapper", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"resizeLayout","elementType":"normal", "applyTo":"all", "tagNames":"div"}
// ];
const directionData=[
  {"classNames":"vericalDotIcon", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"resizeLayout","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"closeBtn","elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"rwt__tablist","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"widgetBody","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"header", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"commonCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"commonMsgDir", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"trdCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"mdlWrap","elementType":"normal", "applyTo":"all", "tagNames":"div"}
];
@connect(state => ({
  userDetail: state.auth.userDetail,
  tradeBook: state.dashboardRoot.activityReducer.tradeBook,
  limitOrdBook:state.dashboardRoot.activityReducer.limitOrdBook,
  opentradeBook:state.dashboardRoot.instrumentListReducer.opentradeBook,
  language:state.dashboardRoot.commonReducer.language,
  deleteWidgetKey: state.dashboardRoot.dashboardReducer.deleteWidgetKey,
  layout: state.dashboardRoot.dashboardReducer.layout,
  themeName:state.dashboardRoot.dashboardReducer.themeName,
  selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
  checkClickOnAddWidgetFlag:state.dashboardRoot.commonReducer.checkClickOnAddWidgetFlag,
  fontSize: state.auth.userDetail.fontSize,
  selectedLang:state.dashboardRoot.commonReducer.selectedLang,
}), {
  ...dashboardActions,
   ...activityActions,
   ...authActions,
   ...commonActions
})

@track(() => ({ widgetDetails: { widget: i18next.t('trdActivityBook')}}))

export default class TradeActivityComponent extends React.PureComponent {
  static propTypes = {
    userDetail: PropTypes.object,
    tradeBook:PropTypes.array,
    language:PropTypes.string,
    CloseIcon: PropTypes.object,
    keyValue: PropTypes.string.isRequired,
    deleteWidget: PropTypes.func,
    deleteWidgetKey: PropTypes.array,
    layoutChanged: PropTypes.func,
    changeWidgetlayout: PropTypes.func,
    themeName: PropTypes.string,
    resizeTradebook: PropTypes.func,
  };
  state = {
    componentKey : !this.props.userDetail.SUB_TRD && this.props.userDetail.isOpenTrade ? "OpenTrades" : "TradeBook",
    lmtRandomNo:0,
    spotTrdRandomNo:0,
    openTrdRandomNo:0,
    spotrows: [],
    clickedRemove: false,
    deleteWidget:[],
    themeName:'',
    widgetRow:3,
    widgetColumn:1
  }
  componentDidMount() {
    this.setState({lmtRandomNo: this.props.limitOrdBook.randomNo});
    this.setState({spotTrdRandomNo: this.props.tradeBook.randomNo});
    this.setState({deleteWidget: this.props.deleteWidgetKey});
    this.setState({themeName: this.props.themeName});
    const thisComponent = ReactDOM.findDOMNode(this);
    //const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
   // applyClickActive(thisComponent.getElementsByClassName("rwt__tab"), allCssStyleRules, "widgetheader");
    const hoverElementsClassNames = [
      {"elmToHover":thisComponent.getElementsByClassName('closeBtn')[0], "classNames":"closeBtn"},
      {"elmToHover":thisComponent.getElementsByClassName('vericalDotIcon')[0], "classNames":"vericalDotIcon"}
    ];
    ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
  }
  componentDidUpdate(preProps){
    const thisComponent = ReactDOM.findDOMNode(this);
    //const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyClickActive(thisComponent.getElementsByClassName("rwt__tab"), allCssStyleRules, "widgetheader");
   }
  componentWillReceiveProps(nextProps){
    // if(this.props.selectedCssColorTheme !== nextProps.selectedCssColorTheme){
    //   const thisComponent = ReactDOM.findDOMNode(this);
    //   const allCssStyleRules = nextProps.selectedCssColorTheme;
    //  // applyStyle(thisComponent, allCssStyleRules, elementsData);
    //   applyClickActive(thisComponent.getElementsByClassName("rwt__tab"), allCssStyleRules, "widgetheader");
    //   const hoverElementsClassNames = [
    //     {"elmToHover":thisComponent.getElementsByClassName('closeBtn')[0], "classNames":"closeBtn"},
    //     {"elmToHover":thisComponent.getElementsByClassName('vericalDotIcon')[0], "classNames":"vericalDotIcon"}
    //   ];
    //   //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    // };
    if(this.props.themeName !==nextProps.themeName){
      this.setState({themeName: nextProps.themeName});
    }
    if (this.props.selectedLang !== nextProps.selectedLang) {
      const thisComponent = ReactDOM.findDOMNode(this);
      setDirection(ReactDOM.findDOMNode(this),directionData,nextProps.selectedLang);
    }
    // if(nextProps.tradeBook.randomNo !== this.state.spotTrdRandomNo) {
    //   this.setState({componentKey:"TradeBook"});
    //   this.setState({spotTrdRandomNo: nextProps.tradeBook.randomNo});
    //   this.selectedComponent("TradeBook");
    // }
    // if(nextProps.limitOrdBook.randomNo !== this.state.lmtRandomNo){
    //   this.setState({componentKey : "OrderBook"});
    //   this.setState({lmtRandomNo: nextProps.limitOrdBook.randomNo});
    //   this.selectedComponent("OrderBook");
    // }
    // if(nextProps.opentradeBook.randomNo !== this.state.openTrdRandomNo){
    //   this.setState({componentKey : "OpenTrades"});
    //   this.setState({openTrdRandomNo: nextProps.opentradeBook.randomNo});
    //   this.selectedComponent("OpenTrades");
    // }
    if(this.state.deleteWidget !== nextProps.deleteWidgetKey){
      this.setState({clickedRemove: false});
      this.setState({deleteWidget: nextProps.deleteWidgetKey});
    }
  }
  selectedComponent = (compntkey) => {
    try{
      this.setState({componentKey : compntkey});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'selectedComponent', component:"TradeActivityComponent"});
    }
  }
  closeWidget = (keyValue) => {
    try{
      this.setState({clickedRemove: true});
      this.props.layoutChanged(1);
      this.props.deleteWidget(keyValue);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeWidget', component:"TradeActivityComponent"});
    }
  }
  onClick = (e, data) => {
    try{
      if(data.rowNumber<=4 && data.columnNumber<=1){
        this.props.resizeTradebook(1,3,this.props.keyValue);
      }else{
        this.props.resizeTradebook(data.rowNumber+1,data.columnNumber+1,this.props.keyValue);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onClick', component:"TradeActivityComponent"});
    }
  }
  render() {
    const selectedfont_size = "fontSize_"+this.props.userDetail.fontSize;
    const selectedLang = "lang_"+this.props.userDetail.LN+"_"+this.props.userDetail.fontSize;
   //const closeImg = <div className={`${styles.closeImgDiv} closeIcon`}><img width="16px" src="/images/close.png"/></div>;
   const {CloseIcon} = this.props;
    return (
      <div className={styles.trdeBookWidget}>
        {!this.state.clickedRemove ?
        <div className="widgetwrapper">
          <Tabs  defaultTab={this.state.componentKey} onChange={this.selectedComponent} className={` ${selectedfont_size} widget_header_tabs `} id="trdActivityTab">
              <div className={`widgetheader headerInnerTrdBook`} >
                <span onClick={() => this.closeWidget(this.props.keyValue)} >{CloseIcon}</span>
                <span className="vericalDotIcon"></span>
                <div className={`resizeLayout`}>
                  <HoverTable
                  column={5}
                  row={5}
                  width={110}
                  height={110}
                  selectedRow={this.props.height-1}
                  selectedColumn={this.props.width-1}
                  onClick={this.onClick}
                  showDimension={true} // show dimension or not
                  onMouseOut={this.onMouseOut}
                  onMouseOver={this.onMouseOver}
                  theme="light"
                  defaultColumn={2}
                  defaultRow={0}
                  />
                </div>
                <TabList>
                  {!this.props.userDetail.SUB_TRD && this.props.userDetail.isOpenTrade? <Tab tabFor="OpenTrades" className={`${selectedfont_size} ${selectedLang} tabName`}>{i18next.t('openTrd')}</Tab>:null}
                  <Tab tabFor="TradeBook" className={`${selectedfont_size} ${selectedLang} tabName`}>{i18next.t('trdBook')}</Tab>
                  {this.props.userDetail.enableCustomerOrder ? <Tab tabFor="OrderBook" className={`${selectedfont_size} ${selectedLang} tabName`}>{i18next.t('orderBook')}</Tab>:null}
                  {this.props.userDetail.enableFXOrd ? <Tab tabFor="Fixings" className={`${selectedfont_size} ${selectedLang} tabName`}>{i18next.t('fixings')}</Tab>:null}
                  <Tab tabFor="ActivityLog" className={`${selectedfont_size} ${selectedLang} tabName`}>{i18next.t('activityLog')}</Tab>
                  <Tab tabFor="NewsFeed" className={`${selectedfont_size} ${selectedLang} tabName`}>{i18next.t('newsFeed')}</Tab>
                </TabList>
              </div>
              <div className={styles.widgetbody}>
                {!this.props.userDetail.SUB_TRD && this.props.userDetail.isOpenTrade ? <TabPanel tabId="OpenTrades"><OpenTradeComponent  props={this.props.language}/></TabPanel>:null}
                <TabPanel tabId="TradeBook"><SpotOrderTableComponent props={this.props.language} keyValue={this.props.keyValue}/></TabPanel>
                {this.props.userDetail.enableCustomerOrder ? <TabPanel tabId="OrderBook"><LimitOrderTableComponent props={this.props.language} keyValue={this.props.keyValue}/></TabPanel>:null}
                {this.props.userDetail.enableFXOrd ? <TabPanel tabId="Fixings"><FixingOrderTableComponent props={this.props.language} keyValue={this.props.keyValue}/></TabPanel>:null}
                <TabPanel tabId="ActivityLog"><ActivityLogComponent  props={this.props.language}/></TabPanel>
                <TabPanel tabId="NewsFeed"><NewsFeedComponent  props={this.props.language}/></TabPanel>
            </div>
          </Tabs>
        </div>
        :null}
      </div>
    );
  }
}
